import { useEffect } from 'react'
 
const win = window;
 
function AnalyticsScript() {
    useEffect(() => {
        win.__ANALYTICS_CONFIG__ = {
            mixpanelEnabled: win.mixpanel_enabled,
            projectToken: win.mixpanel_token,
            saltKey: win.mixpanel_saltkey
        };
 
        const script = document.createElement("script");
        script.src = win.mixpanel_url
 
        script.type = "text/javascript";
        document.head.appendChild(script);
 
        return () => {
            document.head.removeChild(script);
        };
    }, []);
 
    return null;
}
 
export default AnalyticsScript